export default {
	API_BASE_URL: process.env.NODE_ENV === 'development' ? 'http://localhost:4010/api' : '/api'
};



// WEBPACK FOOTER //
// ./src/config.js